var mod = function mod(n, m) {
  return (n % m + m) % m;
};

module.exports = mod;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/math/mod.js
// module id = 65
// module chunks = 0